import React, { useState } from "react";
import Modal from "react-modal";
import { X, Upload as UploadIcon } from "lucide-react";

const ImportSuppliersModal = ({ isOpen, onClose, onImport }) => {
  const [file, setFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setFile(e.dataTransfer.files[0]);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleImport = () => {
    setShowConfirmModal(true);
  };

  const handleProceed = () => {
    if (onImport) {
      onImport({
        file
      });
    }
    handleClose();
  };

  const handleClose = () => {
    setFile(null);
    setDragActive(false);
    setShowConfirmModal(false);
    onClose();
  };

  return (
    <>
      <Modal
        isOpen={isOpen && !showConfirmModal}
        onRequestClose={handleClose}
        className="import-products-modal"
        overlayClassName="import-products-modal-overlay"
        ariaHideApp={false}
      >
        <div className="import-products-modal-content">
          <button className="import-products-close-btn-top" onClick={handleClose}>
            <X size={20} />
          </button>
          
          <div className="import-products-body">
            <h3 className="import-products-card-title">Import Suppliers</h3>
            
            <div className="import-products-form-card">
              
              {/* File Upload */}
              <div className="import-products-field">
                <label className="import-products-label">File Upload</label>
                <div
                  className={`import-products-upload-area ${dragActive ? "drag-active" : ""}`}
                  onDragEnter={handleDrag}
                  onDragLeave={handleDrag}
                  onDragOver={handleDrag}
                  onDrop={handleDrop}
                >
                  <input
                    type="file"
                    id="file-upload"
                    className="import-products-file-input"
                    accept=".csv,.xlsx,.xls"
                    onChange={handleFileChange}
                  />
                  <label htmlFor="file-upload" className="import-products-upload-label">
                    <UploadIcon size={24} className="import-products-upload-icon" />
                    <span className="import-products-upload-text">
                      Upload / Drag to upload file
                    </span>
                    {file && (
                      <span className="import-products-file-name">{file.name}</span>
                    )}
                  </label>
                </div>
              </div>

              {/* Buttons */}
              <div className="import-products-card-actions">
                <button className="import-products-cancel-btn" onClick={handleClose}>
                  Cancel
                </button>
                <button className="import-products-import-btn" onClick={handleImport}>
                  Import
                </button>
              </div>

              {/* Note */}
              <p className="import-products-note">
                Note: The file you upload must follow the exact column order from the table. Files that do not follow this order may result in errors or incorrect data processing.
              </p>
            </div>
          </div>
        </div>
      </Modal>

      {/* Confirm Import Modal */}
      <Modal
        isOpen={showConfirmModal}
        onRequestClose={() => setShowConfirmModal(false)}
        className="import-confirm-modal"
        overlayClassName="import-confirm-modal-overlay"
        ariaHideApp={false}
      >
        <div className="import-confirm-modal-content">
          <h2 className="import-confirm-title">Confirm Import</h2>
          
          <div className="import-confirm-messages">
            <p className="import-confirm-text">
              Please make sure your Supplier IDs are correct.
            </p>
            <p className="import-confirm-text">
              If a Supplier ID in your file matches an existing Supplier ID, this import will update/overwrite that supplier's details.
            </p>
          </div>

          {/* Buttons */}
          <div className="import-confirm-actions">
            <button className="import-confirm-proceed-btn" onClick={handleProceed}>
              Proceed
            </button>
            <button 
              className="import-confirm-cancel-text" 
              onClick={() => setShowConfirmModal(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ImportSuppliersModal;

